import React, { useEffect } from 'react';
import styles from './Modal.module.scss';
import Icon from '../Icons';

type ModalProps = {
  open: boolean;
  close?: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  className?: string;
  title?: string;
};

const className = 'modal';

const Modal: React.FC<ModalProps> = ({ close = false, open, onClose, children,
  className: classNameProps, title
}) => {
  useEffect(() => {
    if (open) {
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';

      return () => {
        // Restore body scroll when modal closes
        document.body.style.overflow = '';
      };
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={`${styles[className]}`}
      data-testid="modal-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.4)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)'

      }}
      onClick={close ? onClose : undefined}
    >
      <div
        className={`${styles[className + '__card']} ${classNameProps}`}
        onClick={e => e.stopPropagation()}
        role="document"
      >
        {(title || close) &&<div className={styles[className + '__card_header']}>
          {title && <h2 className={styles[className + '__card_header_title']}>{title}</h2>}
          {close  && <Icon data-testid="modal-close"
            name="Close" className={styles[className + '__card_header_close']}
            onClick={onClose} />}
        </div>}
        {children}
      </div>
    </div>
  );
};  

export default Modal;